import { useLoaderData } from '@remix-run/react';
import type { DeviceContextType } from '@archipro-website/types';
import type { PaginatedProductsProp } from '@modules/professional/component/products-tab/PaginatedProducts';
import { PaginatedProducts } from '@modules/professional/component/products-tab/PaginatedProducts';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import { useTilesAdminData } from '~/modules-rocco/admin/hooks/use-tiles-admin-data';

interface Loader extends PaginatedProductsProp {
    deviceType: DeviceContextType;
}

const OurProductsPage = () => {
    const loaderData = useLoaderData() as Loader;
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    const productTilesRocco = useTilesAdminData(loaderData.productTilesRocco);

    return (
        <PaginatedProducts
            {...loaderData}
            productTilesRocco={productTilesRocco}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default OurProductsPage;
